import { GetStaticProps, NextPage } from 'next';

import FeedbackPage from '@/views/feedback-page';

const Feedback: NextPage = () => {
  return <FeedbackPage />;
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {
    namespaces: ['shared'],
  },
});

export default Feedback;
